import React from 'react';
import { Replacements } from '../../types';
import { REPLACEMENT_KEYS } from './constants';
import { getOperatingSystem } from './utils';

// Import components from their directories
import OSSettingsButton from './OSSettingsButton';
import OSSettingsLink from './OSSettingsLink';
import RefreshButton from './RefreshButton';
import RefreshLink from './RefreshLink';


/**
 * Creates default BlockKit replacements that can be used across the application
 * @returns {Replacements} Object containing default replacements
 */
export const createDefaultReplacements = (): Replacements => {
  const os = getOperatingSystem(window);
  
  const replacements: Replacements = {
    // OS Settings related replacements
    [REPLACEMENT_KEYS.OS_SETTINGS_BUTTON]: OSSettingsButton({ os, deviceType: "camera", size: "small", color: "primary" }),
    [REPLACEMENT_KEYS.CAMERA_SETTINGS_BUTTON]: OSSettingsButton({ os, deviceType: "camera", size: "small", color: "primary" }),
    [REPLACEMENT_KEYS.MICROPHONE_SETTINGS_BUTTON]: OSSettingsButton({ os, deviceType: "microphone", size: "small", color: "primary" }),
    
    [REPLACEMENT_KEYS.OS_SETTINGS_LINK]: OSSettingsLink({ os, deviceType: "camera" }),
    [REPLACEMENT_KEYS.CAMERA_SETTINGS_LINK]: OSSettingsLink({ os, deviceType: "camera" }),
    [REPLACEMENT_KEYS.MICROPHONE_SETTINGS_LINK]: OSSettingsLink({ os, deviceType: "microphone" }),
    
    // Refresh related replacements
    [REPLACEMENT_KEYS.REFRESH_BUTTON]: RefreshButton({ size: "small", color: "primary" }),
    [REPLACEMENT_KEYS.REFRESH_LINK]: RefreshLink({})
  };
  
  return replacements;
};

export default createDefaultReplacements;
